module.exports = ".reloadtext {\n  text-align: center; }\n\n.reloadtextlink {\n  margin-top: 10px; }\n"